<lib-loading-shimmer [showLoading]="loading()" class="data-table-cell">
  @if (!text()) {
    {{ placeholder() }}
  } @else {
    <lib-general-status-pill [type]="type()">
      {{ text() }}
    </lib-general-status-pill>
  }
</lib-loading-shimmer>
